"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartModal = void 0;
var tailwind_1 = require("../constants/tailwind");
var get_element_1 = require("../utils/get_element");
var IDS = {
    MODAL: 'js-add-cart-modal',
    MODAL_HEADER: 'js-add-cart-modal-header',
};
var CLASSES = {
    MODAL_CLOSE: 'js-add-cart-modal-close',
};
/**
 * カート追加成功時のモーダルお制御するクラス
 */
var CartModal = /** @class */ (function () {
    function CartModal() {
        this.modal = (0, get_element_1.getElementById)(IDS.MODAL);
        this.modalHeader = (0, get_element_1.getElementById)(IDS.MODAL_HEADER);
        this.modalCloseElements = document.querySelectorAll(".".concat(CLASSES.MODAL_CLOSE));
        this.initModalCloseEvent();
    }
    /**
     * シングルトンインスタンスを取得
     * @returns CartModalのインスタンス
     */
    CartModal.getInstance = function () {
        if (!this.instance) {
            this.instance = new CartModal();
        }
        return this.instance;
    };
    /**
     * モーダルを閉じるイベントを初期化
     */
    CartModal.prototype.initModalCloseEvent = function () {
        var _this = this;
        this.modalCloseElements.forEach(function (el) {
            el.addEventListener('click', function () {
                _this.modal.classList.add(tailwind_1.TAILWIND_CLASSES.HIDDEN);
            });
        });
    };
    /**
     * モーダルを表示する
     * @param {string} message モーダルに表示するメッセージ
     */
    CartModal.prototype.showModal = function (message) {
        this.modalHeader.textContent = message;
        this.modal.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
    };
    return CartModal;
}());
exports.CartModal = CartModal;
